import React from 'react';
import FadeIn from 'react-fade-in';

function ListMaker(props) {
  return (
    <section className="align-left-top primary-content">
      <div className="flex-wrap">
        {
          props.list.map((listValue, i) => {
            if (props.type === 'clients') {
              return (
                <FadeIn className="card-wrap col-1-4" transitionDuration={750}>
                  <div className="card" key={i}>{listValue}</div>
                </FadeIn>
              )
            } else {
              return (
                <FadeIn className="card-wrap col-1-4" transitionDuration={750}>
                  <div className="card" key={i}>{listValue}</div>
                </FadeIn>
              )
            }
        })
        }
      </div>
    </section>
  )
}
export default ListMaker